import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=2b18935a&scoped=true&"
import script from "./Index.vue.js?vue&type=script&lang=js&"
export * from "./Index.vue.js?vue&type=script&lang=js&"
import style0 from "./Index.vue?vue&type=style&index=0&id=2b18935a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b18935a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
